// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function suspension_history_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var expiry_time = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expiry_time"), null));
  if (expiry_time.TAG === /* Ok */0) {
    var reason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "reason"), null));
    if (reason.TAG === /* Ok */0) {
      var comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
      if (comment.TAG === /* Ok */0) {
        var $$event = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
        if ($$event.TAG === /* Ok */0) {
          var administrator = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "administrator"), null));
          if (administrator.TAG === /* Ok */0) {
            var event_mode = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "event_mode"), null));
            if (event_mode.TAG === /* Ok */0) {
              var event_time = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "event_time"), null));
              if (event_time.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          expiry_time: expiry_time._0,
                          reason: reason._0,
                          comment: comment._0,
                          event: $$event._0,
                          administrator: administrator._0,
                          event_mode: event_mode._0,
                          event_time: event_time._0
                        }
                      };
              }
              var e = event_time._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".event_time" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = event_mode._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".event_mode" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = administrator._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".administrator" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = $$event._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".event" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = comment._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".comment" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = reason._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".reason" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = expiry_time._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".expiry_time" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var suspend_status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "suspend_status"), null));
  if (suspend_status.TAG === /* Ok */0) {
    var driver_suspension_history = Decco.listFromJson(suspension_history_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_suspension_history"), null));
    if (driver_suspension_history.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                suspend_status: suspend_status._0,
                driver_suspension_history: driver_suspension_history._0
              }
            };
    }
    var e = driver_suspension_history._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".driver_suspension_history" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = suspend_status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".suspend_status" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function res_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var suspension_info = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "suspension_info"), null));
  if (suspension_info.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              suspension_info: suspension_info._0
            }
          };
  }
  var e = suspension_info._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".suspension_info" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function suspension_history_res_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var success = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "success"), null));
  if (success.TAG === /* Ok */0) {
    var data = Decco.listFromJson(suspension_history_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "data"), null));
    if (data.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                success: success._0,
                data: data._0
              }
            };
    }
    var e = data._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".data" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = success._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".success" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  suspension_history_decode ,
  t_decode ,
  res_decode ,
  suspension_history_res_decode ,
  
}
/* No side effect */
